import {throwError as observableThrowError, Observable} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Injectable, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../../../services/base.service';
import {Paging} from '../../../models/latipay/paging.model';
import {Constants} from '../../../constants/app.constant';


@Injectable({providedIn: 'root'})
export class TicketRecordService extends BaseService implements OnInit {

    constructor(public http: HttpClient) {
        super('virtual_good_order', http);
    }

    ngOnInit(): void {
    }

    getAllByPaging(searchCondition: string, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        return this.http.get(`${this.url}?${paging.getPagingStr()}${this.embeddedStr + searchCondition}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllCouponRecordByPaging(searchCondition: string, paging: Paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        let ticketStr = '&f_category=3&f_category_op==';
        return this.http.get(`${Constants.API_ENDPOINT}v1/virtual_good_order?${paging.getPagingStr()}${this.embeddedStr + searchCondition + ticketStr}&sort=id,desc`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));

    }


    getAllByBusinessIdByPaging(searchCondition: string, businessId: number, paging: any) {
        if (!searchCondition) {
            searchCondition = '';
        }

        return this.http.get(`${this.url}?${paging.getPagingStr()}${this.embeddedStr + searchCondition}&sort=id,desc` + (businessId ? `&f_businessId=${businessId}&f_businessId_op==` : '')).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res)));
    }

    getAllByWalletIdsByPaging(walletIds: string[], paging: Paging) {
        const sortStr = '&sort=id,asc';
        let walletIdsStr = '';
        if (walletIds) {
            walletIds.forEach(id => {
                walletIdsStr += `&f_acceptedMerchants=${id}`;
            })
        }
        if (walletIdsStr) {
            walletIdsStr += '&f_acceptedMerchants_op=IN';
        }
        return this.http.get(`${this.url}?${paging.getPagingStr()}${walletIdsStr}${sortStr}`).pipe(
            map((response) => response), catchError((res: any) => observableThrowError(res))
        );
    }
}
